import { useMediaQuery, useTheme } from "@mui/material";

/**
 * True on tablet/desktop-width viewports. inventory-pwa is mobile-first (field staff on phones and
 * tablets in greenhouses/warehouses), so the shell defaults to the mobile layout and only widens
 * the chrome at the `md` breakpoint. Backed by a media query rather than a Redux layout slice — the
 * app has no need for the desktop layout slice worksuite-pwa carries.
 */
const useIsWideScreen = (): boolean => {
	const theme = useTheme();
	return useMediaQuery(theme.breakpoints.up("md"));
};

export default useIsWideScreen;
